import React from "react";
import "./actualemp.css";
import EmpHeader from "./sub-Employee/EmpHeader";
import EmpContent from "./sub-Employee/EmpContent";

function ActualEmp () {
    return(
        <div className="container mainactualemp">
            <div className="row">
                <div className="col-12 ActuaEmp" >
                    <EmpHeader emptitle={"Actual Employees"}/>
                    <EmpContent />
                </div>
            </div>
        </div>
    )
};

export default ActualEmp ;